import BaseController from "./BaseController";
import DataService from "../util/DataService";
import List from "sap/m/List";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class Home extends BaseController {

    public onInit(): void {
        const oRouter = this.getOwnerComponent().getRouter();
        oRouter.getRoute("home").attachPatternMatched(this.onRouteMatched, this);
    }

    onAfterRendering(): void | undefined {
        const upcomingLeaves = this.byId("idItemsUpcomingLeavesList") as List;
        const upcomingSubstitutes = this.byId("idItemsUpcomingSubstitutesList") as List;
        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD

        const aFilters = [
            new Filter("endDate", FilterOperator.GT, formattedCurrentDate),
            new Filter({
                filters: [
                    new Filter("status", FilterOperator.EQ, "APPROVED"),
                    new Filter("status", FilterOperator.EQ, "AUTO_APPROVED")
                ],
                and: false
            })
        ];
        upcomingLeaves.getBinding("items").filter(aFilters);
        upcomingSubstitutes.getBinding("items").filter(aFilters);
    }

    async onRouteMatched(oEvent: any): Promise<void> {
        DataService.getUserData().then((user) => {
            DataService.getLeaveTypes();
            DataService.getUsers();
            DataService.getOrganization();
            DataService.getEnums();
        });
    }

    typeFormatter(value: string): string {
        switch (value) {
            case "pending":
                return "Type01";
            case "APPROVED":
                return "Type08";
            case "AUTO_APPROVED":
                return "Type18";
            case "rejected":
                return "Type02";
            case "forwarded":
                return "Type05";
            case "removed":
                return "Type09";
        }
    }
}
